import React from 'react';
import { Img } from 'react-image';
import styled, { ThemeContext } from 'styled-components';
import Plx from 'react-plx';
import {
  SectionName, buildPlxData,
} from '../common/styles';
import {
  BaseContainer, BaseDesc, BaseTitle,
} from './styles';

const vPadding = 100;
const Container = styled(BaseContainer)`
  ${props => (props.theme.isMobile ? `
    margin-top: 85px;
  ` : `
    margin-top: ${vPadding + 8}px;
    margin-bottom: ${vPadding + 8}px;
  `)};
`;

const Image = styled(Img)`
  ${props => (props.theme.isMobile ? `
    width: 100%;
  ` : `
    max-width: 560px;
    width: 44vw;
  `)};
`;

export default function InvestorEngagement() {
  const { investorEngagementImg, isMobile } = React.useContext(ThemeContext);
  const plxData = buildPlxData('#investor_engagement', vPadding);

  return (
    <Container id="investor_engagement">
      <Plx className="left-section" parallaxData={plxData.text} disabled={isMobile}>
        <SectionName>Solutions</SectionName>
        <BaseTitle>Australia&apos;s most engaged investor platform</BaseTitle>
        <BaseDesc>
          We are levelling the playing field by giving all investors access to
          high-value investment insights, commentary and analysis from Australia&apos;s
          leading money managers.
        </BaseDesc>
      </Plx>
      <Plx className="base-section" parallaxData={plxData.image} disabled={isMobile}>
        <Image src={investorEngagementImg} />
      </Plx>
    </Container>
  );
}
